// import React, { useEffect } from 'react'
// // import TagManager from 'react-gtm-module'
// import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom'
// import Home from './components/Home';
// import CreditCardPage from './components/creditCard/CreditCardPage';
// import Navbar from './components/Navbar/Navbar';
// import FooterComponent from './components/FooterComponent';
// import ResearchPage from './components/research/ResearchPage';
// import AboutPage from './components/about/AboutPage';
// import ContactPage from './components/contact/ContactPage';
// // import InsurancePage from './components/insurance/InsurancePage';
// // import BankDetail from './components/creditCard/BankDetail';
// import AMEX from './components/BankDetails/AMEX'
// import HDFC from './components/BankDetails/HDFC';
// import Au from './components/BankDetails/Au';
// import AXIX from './components/BankDetails/AXIX';
// import ICICI from './components/BankDetails/ICICI';
// import IDFC from './components/BankDetails/IDFC';
// import Indulnd from './components/BankDetails/Indulnd';
// import SBI from './components/BankDetails/SBI';
// import HdfcLearnMore from './components/LearnMore/HdfcLearnMore';
// import BankOfBaroda from './components/BankDetails/BankOfBaroda';
// import Citi from './components/BankDetails/Citi';
// import Federal from './components/BankDetails/Federal';
// import Hsbc from './components/BankDetails/Hsbc';
// import Kotak from './components/BankDetails/Kotak';
// import American from './components/BankDetails/American';
// import Standard from './components/BankDetails/Standard';
// import YesBank from './components/BankDetails/YesBank';
// import CashBack from './components/topButtons/CashBack';
// import Fuel from './components/topButtons/Fuel';
// import LifeTimeFee from './components/topButtons/LifeTimeFee';
// import Premium from './components/topButtons/Premium';
// import Travel from './components/topButtons/Travel';
// import TermsAndConditions from './components/privacy/TermsAndConditions';
// import PrivacyPolicy from './components/privacy/PrivacyPolicy';
// import AuBankLit from './components/featuredCards/AuBankLit';
// import EasyDinerBank from './components/featuredCards/EasyDinerBank';
// import HdfcBankMillennia from './components/featuredCards/HdfcBankMillennia';
// import SbiSimplyClick from './components/featuredCards/SbiSimplyClick';
// import IdfcFirstClassic from './components/featuredCards/IdfcFirstClassic';
// import FlipcartAxixBank from './components/featuredCards/FlipcartAxixBank';
// import LearnMoreAllCards from './components/cardComponents/LearnMoreAllCards';
// import ToolOfSipLipPages from './components/ToolsOfAllBanks/ToolOfSipLipPages';
// import ToolsPages from './components/ToolsOfAllBanks/ToolsPages';
// import SWPCalculator from './components/ToolsOfAllBanks/SWPCalculator';
// import MutualFundCalculator from './components/ToolsOfAllBanks/MutualFundCalculator';
// import SSYCalculator from './components/ToolsOfAllBanks/SSYCalculator';
// import PPFCalculator from './components/ToolsOfAllBanks/PPFCalculator';
// import EPFCalculator from './components/ToolsOfAllBanks/EPFCalculator';
// import FDCalculator from './components/ToolsOfAllBanks/FDCalculator';
// import RDCalculator from './components/ToolsOfAllBanks/RDCalculator';
// import NPSCalculator from './components/ToolsOfAllBanks/NPSCalculator';
// import HRACalculator from './components/ToolsOfAllBanks/HRACalculator';
// import RetirementCalculator from './components/ToolsOfAllBanks/RetirementCalculator';
// import EMICalculator from './components/ToolsOfAllBanks/EMICalculator';
// import Layout from './Layout';
// import SimpleInterestCalculator from './components/ToolsOfAllBanks/SimpleInterestCalculator';
// import CompoundInterestCalculator from './components/ToolsOfAllBanks/CompoundInterestCalculator';
// import NSCCalculator from './components/ToolsOfAllBanks/NSCCalculator';
// import StepUpSIPCalculator from './components/ToolsOfAllBanks/StepUpSIPCalculator';
// import IncomeTaxCalculator from './components/ToolsOfAllBanks/IncomeTaxCalculator';
// import CarLoanEMICalculator from './components/ToolsOfAllBanks/CarLoanEMICalculator';
// import HomeLoanEMICalculator from './components/ToolsOfAllBanks/HomeLoanEMICalculator';
// import GratuityCalculator from './components/ToolsOfAllBanks/GratuityCalculator';
// import APYCalculator from './components/ToolsOfAllBanks/APYCalculator';
// import CAGRCalculator from './components/ToolsOfAllBanks/CAGRCalculator';
// import GSTCalculator from './components/ToolsOfAllBanks/GSTCalculator';
// import FlatReducingRateCalculator from './components/ToolsOfAllBanks/FlatReducingRateCalculator';
// import EquityMarginCalculator from './components/ToolsOfAllBanks/EquityMarginCalculator';
// import InflationCalculator from './components/ToolsOfAllBanks/InflationCalculator';
// import SalaryCalculator from './components/ToolsOfAllBanks/SalaryCalculator';
// import BrokerageCalculator from './components/ToolsOfAllBanks/BrokerageCalculator';
// import TDSCalculator from './components/ToolsOfAllBanks/TDSCalculator';
// import LumpsumCalculator from './components/ToolsOfAllBanks/LumpsumCalculator';
// import SiteMapUi from './components/sitemap/SiteMapUi';
// import LayoutGTM from './LayoutGTM';
// import LayoutScroll from './LayoutScroll';
// import Blogs from './components/blog/Blogs';
// import SinglepageBlog from './components/blog/SinglepageBlog';
// import LoanMainPage from './components/LoanPages/LoanMainPage';
// import SingleLoanPage from './components/LoanPages/SingleLoanPage';
// import DematMainPage from './components/demat/DematMainPage';
// import SingleDematPage from './components/demat/SingleDematPage';
// import InsuranceMainPage from './components/InsuranceNewUi/InsuranceMainPage';
// import SingleInsurancePage from './components/InsuranceNewUi/SingleInsurancePage';
// import { Helmet } from 'react-helmet';
// function App() {

//   // const usePageTracking = () => {
//   //   const location = useLocation();

//   //   useEffect(() => {
//   //     if (window.gtag) {
//   //       window.gtag('config', 'G-DCYD12PDV7', {
//   //         page_path: location.pathname,
//   //       });
//   //     }
//   //   }, [location]);
//   // };

//   //   usePageTracking();

// const location = useLocation()
//   useEffect(() => {

//     window.scrollTo(0, 0);
//   }, [location.pathname]);

//   return (
//     <>
//     <Helmet>
//     <meta name="robots" content="noindex, nofollow" />
//     </Helmet>
//       {/* <Box sx={{ background: '#000' }}> */}
//       <Navbar />
//       {/* <NavBar /> */}
//       <Layout>
//         <LayoutScroll>
//       <Routes>

//         <Route path='/' exact element={<Home />} />

//         <Route path='/insurance_page' element={<InsuranceMainPage />} />
// <Route path='/Insurance_page/:id' element={<SingleInsurancePage />} />

// <Route path='/demat' element={<DematMainPage />} />
// <Route path='/demat/:id' element={<SingleDematPage />} />

//         <Route path='/loan_page/:id' element={<SingleLoanPage />} />
//          <Route path='/loan_page' element={<LoanMainPage />} />

//         <Route path='/blog_page/:id' element={<SinglepageBlog />} />
//         <Route path='/blog_page' element={<Blogs />} />
//         {/* <Route path='/blog_page' element={<Navigate to="/blogpage" replace /> }/> */}

//         <Route path='/sitemap' element={<SiteMapUi />} />
//         <Route path='/financial-tools-calculators/tds-calculator' element={<TDSCalculator />} />
//         <Route path='/financial-tools-calculators/brokerage-calculator' element={<BrokerageCalculator />} />
//         <Route path='/financial-tools-calculators/salary-calculator' element={<SalaryCalculator />} />
//         <Route path='/financial-tools-calculators/inflation-calculator' element={<InflationCalculator />} />
//         <Route path='/financial-tools-calculators/equity-margin-calculator' element={<EquityMarginCalculator />} />
//         <Route path='/financial-tools-calculators/flat-vs-reducing-rate-calculator' element={<FlatReducingRateCalculator />} />
//         <Route path='/financial-tools-calculators/gst-calculator' element={<GSTCalculator />} />
//         <Route path='/financial-tools-calculators/cagr-calculator' element={<CAGRCalculator />} />
//         <Route path='/financial-tools-calculators/apy-calculator' element={<APYCalculator />} />
//         <Route path='/financial-tools-calculators/gratuity-calculator' element={<GratuityCalculator />} />
//         <Route path='/financial-tools-calculators/car-loan-emi-calculator' element={<CarLoanEMICalculator />} />
//         <Route path='/financial-tools-calculators/home-loan-emi-calculator' element={<HomeLoanEMICalculator />} />
//         <Route path='/financial-tools-calculators/income-tax-calculator' element={<IncomeTaxCalculator />} />
//         <Route path='/financial-tools-calculators/step-up-sip-calculator' element={<StepUpSIPCalculator />} />
//         <Route path='/financial-tools-calculators/nsc-calculator' element={<NSCCalculator />} />
//         <Route path='/financial-tools-calculators/compound-interest-calculator' element={<CompoundInterestCalculator />} />
// <Route path='/financial-tools-calculators/simple-interest-calculator' element={<SimpleInterestCalculator />} />
//         <Route path='/financial-tools-calculators/emi-calculator' element={<EMICalculator />} />
//         <Route path='/financial-tools-calculators/retirement-planning-calculator' element={<RetirementCalculator />} />
//         <Route path='/financial-tools-calculators/hra-exemption-calculator' element={<HRACalculator />} />
//         <Route path='/financial-tools-calculators/nps-calculator' element={<NPSCalculator />} />
//         <Route path='/financial-tools-calculators/rd-calculator' element={<RDCalculator />} />
//         <Route path='/financial-tools-calculators/fd-calculator' element={<FDCalculator />} />
//         <Route path='/financial-tools-calculators/pf-epf-calculator' element={<EPFCalculator />} />
//         <Route path='/financial-tools-calculators/ppf-calculator' element={<PPFCalculator />} />
//         <Route path='/financial-tools-calculators/sukanya-samriddhi-yojana-calculator' element={<SSYCalculator />} />
//         <Route path='/financial-tools-calculators/mutual-fund-calculator' element={<MutualFundCalculator />} />
//         <Route path='/financial-tools-calculators/swp-calculator' element={<SWPCalculator />} />
//         <Route path='/financial-tools-calculators' element={<ToolsPages />} />
//         <Route path='/financial-tools-calculators/sip-calculator' element={<ToolOfSipLipPages />} />
//         <Route path='/financial-tools-calculators/lumpsum-calculator' element={<ToolOfSipLipPages />} />
//          <Route path='/learn-more-page/card' element={<LearnMoreAllCards />} />
//         <Route path='/credit-card/aubank-credit-card' element={<AuBankLit />} />
//         <Route path='/credit-card/eazy-diner-indusind-bank-credit-card' element={<EasyDinerBank />} />
//         <Route path='/credit-card/hdfc-bank/millennia-credit-card' element={<HdfcBankMillennia />} />
//         <Route path='/credit-card/sbi-simplyclick-credit-card' element={<SbiSimplyClick />} />
//         <Route path='/credit-card/idfcfirst-classic-credit-card' element={<IdfcFirstClassic />} />
//         <Route path='/credit-card/axis-bank-flipkart-credit-card' element={<FlipcartAxixBank />} />
//         <Route path='/privacy-policy' element={<PrivacyPolicy />} />
//         <Route path='/term-and-conditions' element={<TermsAndConditions />} />
//         <Route path='/amex_detail' element={<AMEX />} />
//         <Route path='/au-bank/credit-card' element={<Au />} />
//         <Route path='/axix-bank/credit-card' element={<AXIX />} />
//         <Route path='/icici-bank/credit-card' element={<ICICI />} />
//         <Route path='/idfc-bank/credit-card' element={<IDFC />} />
//         <Route path='/induslnd-bank/credit-card' element={<Indulnd />} />
//         <Route path='/sbi-bank/credit-card' element={<SBI />} />
//         <Route path='/hdfc-bank/credit-card' element={<HDFC />} />
//         <Route path='/bank-of-baroda/credit-card' element={<BankOfBaroda />} />
//         <Route path='/citi_detail' element={<Citi />} />
//         <Route path='/fedral_detail' element={<Federal />} />
//         <Route path='/hsbc-bank/credit-card' element={<Hsbc />} />
//         <Route path='/kotak_detail' element={<Kotak />} />
//         <Route path='/american-bank/credit-card' element={<American />} />
//         <Route path='/standard-bank/credit-card' element={<Standard />} />
//         <Route path='/yes-bank/credit-card' element={<YesBank />} />
//         <Route path='/hdfc_learn_more' element={<HdfcLearnMore />} />
//         <Route path='/credit-card/travel-credit-card' element={<Travel />} />
//         <Route path='/credit-card/best-cashback-credit-card' element={<CashBack />} />
//         <Route path='/credit-card/best-premium-credit-card' element={<Premium />} />
//         <Route path='/credit-card/best-lifetime-free-credit-cards' element={<LifeTimeFee />} />
//         <Route path='/credit-card/fuel-credit-card' element={<Fuel />} />
//         {/* <Route path='/detailofbank' element={<BankDetail />} /> */}
//         <Route path='/credit-card' element={<CreditCardPage />} />
//         {/* <Route path='/demat' element={<Demat />} /> */}
//         <Route path='/research' element={<ResearchPage />} />
//         <Route path='/about' element={<AboutPage />} />
//         <Route path='/contact-us' element={<ContactPage />} />
//         {/* <Route path='/insurance' element={<InsurancePage />} /> */}
//         {/* <Route path='/blog' element={<BlogPage />} /> */}
//         {/* <Route path='/blog_page/:id' element={<BlogPost />} /> */}
//         {/* <Route path='/video/:id' element={<VideoDetail />} />
//           <Route path='/channel/:id' element={<ChannelDetail />} />
//           <Route path='/search/:searchTerm' element={<SearchFeed />} /> */}
//       </Routes>
//       <LayoutGTM>
//       <FooterComponent />
//       </LayoutGTM>
//       </LayoutScroll>
//       </Layout>

//        {/* </Box> */ }
//     </>

//   );
// }

// export default App;

import React, { useEffect } from "react";

// import TagManager from 'react-gtm-module'
import { Routes, Route, useLocation } from "react-router-dom";
import Home from "./components/Home";
import PersonalLoan from "./components/personalLoan/PersonalLoan";
import CreditCardPage from "./components/creditCard/CreditCardPage";
// import NavBar from './components/NavBar';
// import Navbar from './components/Navbar/Navbar';
import FooterComponent from "./components/FooterComponent";
// import BlogPage from './components/blog/BlogPage';
import ResearchPage from "./components/research/ResearchPage";
import AboutPage from "./components/about/AboutPage";
import ContactPage from "./components/contact/ContactPage";
// import InsurancePage from './components/insurance/InsurancePage';
import LifeInsurance from "./components/insurance/LifeInsurance";
import HealthInsurance from "./components/insurance/HealthInsurance";
import CarInsurance from "./components/insurance/CarInsurance";
import BikeInsurance from "./components/insurance/BikeInsurance";
import TermInsurance from "./components/insurance/TermInsurance";
import TravelInsurance from "./components/insurance/TravelInsurance";
// import BlogPost from './components/blog/BlogPost';
// import BankDetail from './components/creditCard/BankDetail';
import AMEX from "./components/BankDetails/AMEX";
import HDFC from "./components/BankDetails/HDFC";
import Au from "./components/BankDetails/Au";
import AXIX from "./components/BankDetails/AXIX";
import ICICI from "./components/BankDetails/ICICI";
import IDFC from "./components/BankDetails/IDFC";
import Indulnd from "./components/BankDetails/Indulnd";
import SBI from "./components/BankDetails/SBI";
import HdfcLearnMore from "./components/LearnMore/HdfcLearnMore";
import BankOfBaroda from "./components/BankDetails/BankOfBaroda";
import Citi from "./components/BankDetails/Citi";
import Federal from "./components/BankDetails/Federal";
import Hsbc from "./components/BankDetails/Hsbc";
import Kotak from "./components/BankDetails/Kotak";
import American from "./components/BankDetails/American";
import Standard from "./components/BankDetails/Standard";
import YesBank from "./components/BankDetails/YesBank";
import CashBack from "./components/topButtons/CashBack";
import Fuel from "./components/topButtons/Fuel";
import LifeTimeFee from "./components/topButtons/LifeTimeFee";
import Premium from "./components/topButtons/Premium";
import Travel from "./components/topButtons/Travel";
// import Demat from './components/demat/Demat';
import DematLearnMore from "./components/dematLearnMore/DematLearnMore";
import TermsAndConditions from "./components/privacy/TermsAndConditions";
import PrivacyPolicy from "./components/privacy/PrivacyPolicy";
import CarLoan from "./components/personalLoan/CarLoan";
import CarLoanLearnMore from "./components/LearnmorePageLoan/CarLoanLearnMore";

import HomeLoan from "./components/personalLoan/HomeLoan";
import TwoWheelerLoan from "./components/personalLoan/TwoWheelerLoan";
import EducationLoan from "./components/personalLoan/EducationLoan";
import PersonalLoanU from "./components/personalLoan/PersonalLoanU";
import AuBankLit from "./components/featuredCards/AuBankLit";
import EasyDinerBank from "./components/featuredCards/EasyDinerBank";
import HdfcBankMillennia from "./components/featuredCards/HdfcBankMillennia";
import SbiSimplyClick from "./components/featuredCards/SbiSimplyClick";
import IdfcFirstClassic from "./components/featuredCards/IdfcFirstClassic";
import FlipcartAxixBank from "./components/featuredCards/FlipcartAxixBank";
// import UpStoxLearnMore from './components/dematLearnMore/UpStoxLearnMore';
// import AngelOneLearnMore from './components/dematLearnMore/AngelOneLearnMore';
// import HdfcDematLearnMore from './components/dematLearnMore/HdfcDematLearnMore';
// import GrowwDematLearnMore from './components/dematLearnMore/GrowwDematLearnMore';
// import FyersDematLearnMore from './components/dematLearnMore/FyersDematLearnMore';
// import ZerodaDematLearnMore from './components/dematLearnMore/ZerodaDematLearnMore';
import LearnMoreAllCards from "./components/cardComponents/LearnMoreAllCards";
import IciciLombardLearn from "./components/LearnMoreCarInsurance/IciciLombardLearn";
import ToolOfSipLipPages from "./components/ToolsOfAllBanks/ToolOfSipLipPages";
import BajajLearnMore from "./components/LearnMoreCarInsurance/BajajLearnMore";
import AckoLearnMore from "./components/LearnMoreCarInsurance/AckoLearnMore";
import HdfcCarLearnMore from "./components/LearnMoreCarInsurance/HdfcCarLearnMore";
import TataAijLearnMore from "./components/LearnMoreCarInsurance/TataAijLearnMore";
import IciciBikeInsurance from "./components/LearnMoreBikeInsurance/IciciBikeInsurance";
import AckoBikeInsurance from "./components/LearnMoreBikeInsurance/AckoBikeInsurance";
import BajajBikeInsurance from "./components/LearnMoreBikeInsurance/BjajajBikeInsurance";
import FutureBikeInsurance from "./components/LearnMoreBikeInsurance/FutureBikeInsurance";
import HdfcBikeInsurance from "./components/LearnMoreBikeInsurance/HdfcBikeInsurance";
import AdityaLifeLearn from "./components/LearnMoreLifeInsurance/AdityaLifeLearn";
import FutureLifeLearn from "./components/LearnMoreLifeInsurance/FutureLifeLearn";
import HdfcLifeLearn from "./components/LearnMoreLifeInsurance/HdfcLifeLearn";
import IciciLifeLearn from "./components/LearnMoreLifeInsurance/IciciLifeLearn";
import MaxLifeLearn from "./components/LearnMoreLifeInsurance/MaxLifeLearn";
import AdityaHealthLearn from "./components/learnmoreHealthInsurance/AdityaHealthLearn";
import CareHealthLearn from "./components/learnmoreHealthInsurance/CareHealthLearn";
import HdfcargoHealthLearn from "./components/learnmoreHealthInsurance/HdfcargoHealthLearn";
import DigitHealthLearn from "./components/learnmoreHealthInsurance/DigitHealthLearn";
import RelianceHealthLearn from "./components/learnmoreHealthInsurance/RelianceHealthLearn";
import ToolsPages from "./components/ToolsOfAllBanks/ToolsPages";
import SWPCalculator from "./components/ToolsOfAllBanks/SWPCalculator";
import MutualFundCalculator from "./components/ToolsOfAllBanks/MutualFundCalculator";
import SSYCalculator from "./components/ToolsOfAllBanks/SSYCalculator";
import PPFCalculator from "./components/ToolsOfAllBanks/PPFCalculator";
import EPFCalculator from "./components/ToolsOfAllBanks/EPFCalculator";
import FDCalculator from "./components/ToolsOfAllBanks/FDCalculator";
import RDCalculator from "./components/ToolsOfAllBanks/RDCalculator";
import NPSCalculator from "./components/ToolsOfAllBanks/NPSCalculator";
import HRACalculator from "./components/ToolsOfAllBanks/HRACalculator";
import RetirementCalculator from "./components/ToolsOfAllBanks/RetirementCalculator";
import EMICalculator from "./components/ToolsOfAllBanks/EMICalculator";
import Layout from "./Layout";
import SimpleInterestCalculator from "./components/ToolsOfAllBanks/SimpleInterestCalculator";
import CompoundInterestCalculator from "./components/ToolsOfAllBanks/CompoundInterestCalculator";
import NSCCalculator from "./components/ToolsOfAllBanks/NSCCalculator";
import StepUpSIPCalculator from "./components/ToolsOfAllBanks/StepUpSIPCalculator";
import IncomeTaxCalculator from "./components/ToolsOfAllBanks/IncomeTaxCalculator";
import CarLoanEMICalculator from "./components/ToolsOfAllBanks/CarLoanEMICalculator";
import HomeLoanEMICalculator from "./components/ToolsOfAllBanks/HomeLoanEMICalculator";
import GratuityCalculator from "./components/ToolsOfAllBanks/GratuityCalculator";
import APYCalculator from "./components/ToolsOfAllBanks/APYCalculator";
import CAGRCalculator from "./components/ToolsOfAllBanks/CAGRCalculator";
import GSTCalculator from "./components/ToolsOfAllBanks/GSTCalculator";
import FlatReducingRateCalculator from "./components/ToolsOfAllBanks/FlatReducingRateCalculator";
import EquityMarginCalculator from "./components/ToolsOfAllBanks/EquityMarginCalculator";
import InflationCalculator from "./components/ToolsOfAllBanks/InflationCalculator";
import SalaryCalculator from "./components/ToolsOfAllBanks/SalaryCalculator";
import BrokerageCalculator from "./components/ToolsOfAllBanks/BrokerageCalculator";
import TDSCalculator from "./components/ToolsOfAllBanks/TDSCalculator";
// import LumpsumCalculator from './components/ToolsOfAllBanks/LumpsumCalculator';
import SiteMapUi from "./components/sitemap/SiteMapUi";
import LayoutGTM from "./LayoutGTM";
import LayoutScroll from "./LayoutScroll";
import Blogs from "./components/blog/Blogs";
// import SinglepageBlog from './components/blog/SinglepageBlog';
import BajajTravelLearn from "./components/LearnMoreTravelInsurance.js/BajajTravelLearn";
import IciciLombardTravelLearn from "./components/LearnMoreTravelInsurance.js/IciciLombardTravelLearn";
import TataaijTravelLearn from "./components/LearnMoreTravelInsurance.js/TataaijTavelLearn";
import CareHealthTravelLearn from "./components/LearnMoreTravelInsurance.js/CareHealthTravelLearn";
import HdfcErgoTravelLearn from "./components/LearnMoreTravelInsurance.js/HdfcErgoTravelLearn";
import LoanMainPage from "./components/LoanPages/LoanMainPage";
import SingleLoanPage from "./components/LoanPages/SingleLoanPage";
import DematMainPage from "./components/demat/DematMainPage";
import SingleDematPage from "./components/demat/SingleDematPage";
import InsuranceMainPage from "./components/InsuranceNewUi/InsuranceMainPage";
import SingleInsurancePage from "./components/InsuranceNewUi/SingleInsurancePage";
// import ScrollToHashElement from './components/ScrollToHashElement';
import CarInsuranceNew from "./components/AllInsuranceDynamic/CarInsuranceNew";
import CarInsuranceDetail from "./components/AllInsuranceDynamic/CarInsuranceDetail";
import BikeInsuranceNew from "./components/AllInsuranceDynamic/BikeInsuranceNew";
import BikeInsuranceDetail from "./components/AllInsuranceDynamic/BikeInsuranceDetail";
import TravelInsuranceNew from "./components/AllInsuranceDynamic/TravelInsuranceNew";
import HealthInsuranceNew from "./components/AllInsuranceDynamic/HealthInsuranceNew";
import TermLifeInsuranceNew from "./components/AllInsuranceDynamic/TermLifeInsuranceNew";
import CarLoanNew from "./components/AllLoanDynamic/CarLoanNew";
import CarLoanDetail from "./components/AllLoanDynamic/CarLoanDetail";
import TermInsuranceDetail from "./components/AllInsuranceDynamic/TermInsuranceDetail";
import HealthInsuranceDetail from "./components/AllInsuranceDynamic/HealthInsuranceDetail";
import TravelInsuranceDetail from "./components/AllInsuranceDynamic/TravelInsuranceDetail";
import HomeLoanNew from "./components/AllLoanDynamic/HomeLoanNew";
import PersonalLoanNew from "./components/AllLoanDynamic/PersonalLoanNew";
import EducationLoanNew from "./components/AllLoanDynamic/EducationLoanNew";
import TwoWheelerLoanNew from "./components/AllLoanDynamic/TwoWheelerLoanNew";
import GoldLoanNew from "./components/AllLoanDynamic/GoldLoanNew";
import BusinessLoanNew from "./components/AllLoanDynamic/BusinessLoanNew";
import NavBarNew from "./components/NavbarNew";
import EducationLoanDetail from "./components/AllLoanDynamic/EducationLoanDetail";
import PersonalLoanDetail from "./components/AllLoanDynamic/PersonalLoanDetail";
import HomeLoanDetail from "./components/AllLoanDynamic/HomeLoanDetail";
import BusinessLoanDetail from "./components/AllLoanDynamic/BusinessLoanDetail";
import GoldLoanDetail from "./components/AllLoanDynamic/GoldLoanDetail";
import KotakMahindra from "./components/BankDetails/KotakMahindra";
import Rbl from "./components/BankDetails/Rbl";
import PnbBank from "./components/BankDetails/PnbBank";
import UnionBank from "./components/BankDetails/UnionBanks";
import CanaraBank from "./components/BankDetails/CanaraBank";
import BoiBank from "./components/BankDetails/Boi";
import DBS from "./components/BankDetails/DBS";
import IndianBank from "./components/BankDetails/IndianBank";
import UjjivanBank from "./components/BankDetails/UjjivanBank";
import Equitas from "./components/BankDetails/Equitas";
import CityBank from "./components/BankDetails/CityBank";
import SouthIndianBank from "./components/BankDetails/SouthIndianBank";
import DcbBank from "./components/BankDetails/DcbBank";
import JKBank from "./components/BankDetails/JKBank";
import KvbBank from "./components/BankDetails/KvbBank";
import ContactModal from "./components/contact/ContactModal";
import InsuranceNewUiHome from "./components/AllInsuranceDynamic/InsuranceNewUiHome";
import LoanInsuranceNewUiHome from "./components/AllLoanDynamic/LoanInsuranceNewUiHome";
// import BlogNewUiPage from './components/blog/BlogNewUiPage';
import SingleBlogNew from "./components/blog/SingleBlogNew";
import TwoWheelerLoanDetail from "./components/AllLoanDynamic/TwoWheelerLoanDetail";
import RewardCredit from "./components/topButtons/RewardCredit";
import BusinessCreditCard from "./components/topButtons/BuisnessCreditCard";
import LifeStyleCreditCard from "./components/topButtons/LifeStyleCreditCard";
// import TermLifeInsurance from './components/ToolsOfAllBanks/TermLifeInsurance';
import TermLifeInsuranceCalculator from "./components/ToolsOfAllBanks/TermLifeInsuranceCalculator";
import TravelInsuranceCalculator from "./components/ToolsOfAllBanks/TravelLifeInsuranceCalculator";
import CarInsuranceCalculator from "./components/ToolsOfAllBanks/CarInsuranceCalculator";
import BikeInsuranceCalculator from "./components/ToolsOfAllBanks/BikeInsuranceCalculator";
import HealthInsuranceCalculator from "./components/ToolsOfAllBanks/HealthInsuranceCalculator";
import HdfcSipCalculator from "./components/ToolsOfAllBanks/HdfcSipCalculator";
import IciciSipCalculator from "./components/ToolsOfAllBanks/IciciSipCalculator";
import AxixSipCalculator from "./components/ToolsOfAllBanks/AxixSipCalculator";
import KotakSipCalculator from "./components/ToolsOfAllBanks/KotakSipCalculator";
import CanaraBankCalculator from "./components/ToolsOfAllBanks/CanaraBankCalculator";
import SbiSipCalculator from "./components/ToolsOfAllBanks/SbiSipCalculator";
import NipponSipCalculator from "./components/ToolsOfAllBanks/NipponSipCalculator";
import LicSipCalculator from "./components/ToolsOfAllBanks/LicSipBankCalculator";
import PnbSipCalculator from "./components/ToolsOfAllBanks/PnbSipCalculator";
import IDBISipCalculator from "./components/ToolsOfAllBanks/IDBISipCalculator";
import GoldLoanEmiCalculator from "./components/ToolsOfAllBanks/GoldLoanEmiCalculator";
import PersonalLoanEmiCalculator from "./components/ToolsOfAllBanks/PersonalLoanEmiCalculator";
import BusinessLoanEmiCalculator from "./components/ToolsOfAllBanks/BusinessLoanEmiCalculator";
import EducationLoanEmiCalculator from "./components/ToolsOfAllBanks/EducationLoanEmiCalculator";
import TwowheelerLoanEmiCalculator from "./components/ToolsOfAllBanks/TwowheelerLoanEmiCalculator";
import SbiLoanEmiCalculator from "./components/ToolsOfAllBanks/SbiLoanEmiCalculator";
import AxixCarLoanEmiCalculator from "./components/ToolsOfAllBanks/AxixCarLoanEmiCalculator";
import IciciCarloanEmiCalculator from "./components/ToolsOfAllBanks/IciciCarloanEmiCalculator";
import HdfcCarLoanEmiCalculator from "./components/ToolsOfAllBanks/HdfcCarLoanEmiCalculator";
import CanaraCarLoanEmiCalculator from "./components/ToolsOfAllBanks/CanaraCarLoanEmiCalculator";
import PnbCarLoanEmiCalculator from "./components/ToolsOfAllBanks/PnbCarLoanEmiCalculator";
import UninonBankCarLoanEmiCalculator from "./components/ToolsOfAllBanks/UninonBankCarLoanEmiCalculator";
import BobCarLoanEmiCalculator from "./components/ToolsOfAllBanks/BobCarLoanEmiCalculator";
import BomCarLoanEmiCalculator from "./components/ToolsOfAllBanks/BomCarLoanEmiCalculator";
import DhanlaxmiCarloanEMiCalculator from "./components/ToolsOfAllBanks/DhanlaxmiCarloanEMiCalculator";
import SbiBikeLoanEmiCalculator from "./components/ToolsOfAllBanks/SbiBikeLoanEmiCalculator";
import HdfcBikeLoanEmiCalculator from "./components/ToolsOfAllBanks/HdfcBikeLoanEmiCalculator";
import IciciBankBikeLoanEmi from "./components/ToolsOfAllBanks/IciciBankBikeLoanEmi";
import AxixBankBikeloanEmi from "./components/ToolsOfAllBanks/AxixBankBikeloanEmi";
import BajajFinserveBikeloanEmi from "./components/ToolsOfAllBanks/BajajFinserveBikeloanEmi";
import KotakMahindraBikeEMiCalculator from "./components/ToolsOfAllBanks/KotakMahindraBikeEMiCalculator";
import TataCapitalBikeEmiCalculator from "./components/ToolsOfAllBanks/TataCapitalBikeEmiCalculator";
import MahindraFinanceBikeEmi from "./components/ToolsOfAllBanks/MahindraFinanceBikeLoanEmi";
import MuthootFinanceBikeLoanEmi from "./components/ToolsOfAllBanks/MuthootFinanceBikeLoanEmi";
import SbihomeLoanEmiCalculator from "./components/ToolsOfAllBanks/SbihomeLoanEmiCalculator";
import HdfcHomeLoanEMiCalculator from "./components/ToolsOfAllBanks/HdfcHomeLoanEMiCalculator";
import IciciHomeLoanEmiCalculator from "./components/ToolsOfAllBanks/IciciHomeLoanEmiCalculator";
import AxisHomeLoanEmiCalculator from "./components/ToolsOfAllBanks/AxisHomeLoanEmiCalculator";
import LicHousingFinanceHomeLoan from "./components/ToolsOfAllBanks/LicHousingFinanceHomeLoan";
import BobHomeLoanEmiCalculator from "./components/ToolsOfAllBanks/BobHomeLoanEmiCalculator";

function App() {
  // const usePageTracking = () => {
  //   const location = useLocation();

  //   useEffect(() => {
  //     if (window.gtag) {
  //       window.gtag('config', 'G-DCYD12PDV7', {
  //         page_path: location.pathname,
  //       });
  //     }
  //   }, [location]);
  // };

  //   usePageTracking();

  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <>
      {/* <Box sx={{ background: '#000' }}> */}
      {/* <Navbar /> */}
      <NavBarNew />
      {/* <NavBar /> */}
      {/* <ScrollToHashElement/> */}
      <Layout>
        <LayoutScroll>
          <ContactModal/> 
          <Routes>
            <Route path="/" exact element={<Home />} />
            <Route path="/blog" element={<Blogs />} />
            <Route path="/blog/:id" element={<SingleBlogNew />} />

            <Route path="/loan" element={<LoanInsuranceNewUiHome />} />

            <Route path="/business_loan" element={<BusinessLoanNew />} />
            <Route
              path="/business_loan/:pageUrl"
              element={<BusinessLoanDetail />}
            />

            <Route path="/gold_loan" element={<GoldLoanNew />} />
            <Route path="/gold_loan/:pageUrl" element={<GoldLoanDetail />} />

            <Route path="/two_wheeler_loan" element={<TwoWheelerLoanNew />} />
            <Route
              path="/two_wheeler_loan/:pageUrl"
              element={<TwoWheelerLoanDetail />}
            />

            <Route path="/education_loan" element={<EducationLoanNew />} />
            <Route
              path="/education_loan/:pageUrl"
              element={<EducationLoanDetail />}
            />

            <Route path="/personal_loan" element={<PersonalLoanNew />} />
            <Route
              path="/personal_loan/:pageUrl"
              element={<PersonalLoanDetail />}
            />

            <Route path="/home_loan" element={<HomeLoanNew />} />
            <Route path="/home_loan/:pageUrl" element={<HomeLoanDetail />} />

            <Route path="/car_loan" element={<CarLoanNew />} />
            <Route path="/car_loan/:pageUrl" element={<CarLoanDetail />} />
            <Route path="/insurance" element={<InsuranceNewUiHome />} />

            <Route
              path="/termlife_insurance"
              element={<TermLifeInsuranceNew />}
            />
            <Route
              path="/termlife_insurance/:pageUrl"
              element={<TermInsuranceDetail />}
            />

            <Route path="/health_insurance" element={<HealthInsuranceNew />} />
            <Route
              path="/health_insurance/:pageUrl"
              element={<HealthInsuranceDetail />}
            />

            <Route path="/travel_insurance" element={<TravelInsuranceNew />} />
            <Route
              path="/travel_insurance/:pageUrl"
              element={<TravelInsuranceDetail />}
            />

            <Route path="/bike_insurance" element={<BikeInsuranceNew />} />
            <Route
              path="/bike_insurance/:pageUrl"
              element={<BikeInsuranceDetail />}
            />

            <Route path="/car_insurance" element={<CarInsuranceNew />} />
            <Route
              path="/car_insurance/:pageUrl"
              element={<CarInsuranceDetail />}
            />

            <Route path="/insurance_page" element={<InsuranceMainPage />} />
            <Route
              path="/Insurance_page/:id"
              element={<SingleInsurancePage />}
            />

            <Route path="/demat" element={<DematMainPage />} />
            <Route path="/demat/:id" element={<SingleDematPage />} />

            <Route path="/loan_page/:id" element={<SingleLoanPage />} />
            <Route path="/loan_page" element={<LoanMainPage />} />

            {/* <Route path='/blog_page/:id' element={<SinglepageBlog />} /> */}
            {/* <Route path='/blog_page' element={<Blogs />} /> */}
            {/* <Route path='/blog_page' element={<Navigate to="/blogpage" replace /> }/> */}
        
            <Route path="/sitemap" element={<SiteMapUi />} />
            <Route
              path="/financial-tools-calculators/bob-home-loan-emi-calculator"
              element={<BobHomeLoanEmiCalculator/>}
            />
            <Route
              path="/financial-tools-calculators/lic-housing-finance-home-loan-emi-calculator"
              element={<LicHousingFinanceHomeLoan/>}
            />
            <Route
              path="/financial-tools-calculators/axis-home-loan-emi-calculator"
              element={<AxisHomeLoanEmiCalculator/>}
            />
            <Route
              path="/financial-tools-calculators/icici-home-loan-emi-calculator"
              element={<IciciHomeLoanEmiCalculator/>}
            />
            <Route
              path="/financial-tools-calculators/hdfc-home-loan-emi-calculator"
              element={<HdfcHomeLoanEMiCalculator/>}
            />
            <Route
              path="/financial-tools-calculators/sbi-home-loan-emi-calculator"
              element={<SbihomeLoanEmiCalculator/>}
            />
            <Route
              path="/financial-tools-calculators/muthoot-finance-bank-bike-loan-emi-calculator"
              element={<MuthootFinanceBikeLoanEmi/>}
            />
            <Route
              path="/financial-tools-calculators/mahindra-finance-bank-bike-loan-emi-calculator"
              element={<MahindraFinanceBikeEmi/>}
            />
            <Route
              path="/financial-tools-calculators/tata-capital-bank-bike-loan-emi-calculator"
              element={<TataCapitalBikeEmiCalculator/>}
            />
            <Route
              path="/financial-tools-calculators/kotak-mahindra-bank-bike-loan-emi-calculator"
              element={<KotakMahindraBikeEMiCalculator/>}
            />
            <Route
              path="/financial-tools-calculators/bajaj-finserv-bank-bike-loan-emi-calculator"
              element={<BajajFinserveBikeloanEmi/>}
            />
            <Route
              path="/financial-tools-calculators/axis-bank-bike-loan-emi-calculator"
              element={<AxixBankBikeloanEmi/>}
            />
            <Route
              path="/financial-tools-calculators/icici-bank-bike-loan-emi-calculator"
              element={<IciciBankBikeLoanEmi/>}
            />
            <Route
              path="/financial-tools-calculators/hdfc-bank-bike-loan-emi-calculator"
              element={<HdfcBikeLoanEmiCalculator/>}
            />
            <Route
              path="/financial-tools-calculators/sbi-bank-bike-loan-emi-calculator"
              element={<SbiBikeLoanEmiCalculator/>}
            />
            <Route
              path="/financial-tools-calculators/dhanlaxmi-bank-car-loan-emi-calculator"
              element={<DhanlaxmiCarloanEMiCalculator/>}
            />
            <Route
              path="/financial-tools-calculators/bank-of-maharashtra-car-loan-emi-calculator"
              element={<BomCarLoanEmiCalculator/>}
            />
            <Route
              path="/financial-tools-calculators/bank-of-baroda-car-loan-emi-calculator"
              element={<BobCarLoanEmiCalculator/>}
            />
            <Route
              path="/financial-tools-calculators/Union-car-loan-emi-calculator"
              element={<UninonBankCarLoanEmiCalculator />}
            />
            <Route
              path="/financial-tools-calculators/pnb-car-loan-emi-calculator"
              element={<PnbCarLoanEmiCalculator />}
            />
            <Route
              path="/financial-tools-calculators/canara-car-loan-emi-calculator"
              element={<CanaraCarLoanEmiCalculator />}
            />
            <Route
              path="/financial-tools-calculators/hdfc-car-loan-emi-calculator"
              element={<HdfcCarLoanEmiCalculator />}
            />
            <Route
              path="/financial-tools-calculators/icici-car-loan-emi-calculator"
              element={<IciciCarloanEmiCalculator />}
            />
            <Route
              path="/financial-tools-calculators/axis-car-loan-emi-calculator"
              element={<AxixCarLoanEmiCalculator />}
            />
            <Route
              path="/financial-tools-calculators/sbi-car-loan-emi-calculator"
              element={<SbiLoanEmiCalculator />}
            />
            <Route
              path="/financial-tools-calculators/two-wheeler-loan-emi-calculator"
              element={<TwowheelerLoanEmiCalculator />}
            />
            <Route
              path="/financial-tools-calculators/education-loan-emi-calculator"
              element={<EducationLoanEmiCalculator />}
            />
            <Route
              path="/financial-tools-calculators/business-loan-emi-calculator"
              element={<BusinessLoanEmiCalculator />}
            />
            <Route
              path="/financial-tools-calculators/personal-loan-emi-calculator"
              element={<PersonalLoanEmiCalculator />}
            />
            <Route
              path="/financial-tools-calculators/gold-loan-emi-calculator"
              element={<GoldLoanEmiCalculator />}
            />
            <Route
              path="/financial-tools-calculators/idbi-bank-sip-calculator"
              element={<IDBISipCalculator />}
            />

            <Route
              path="/financial-tools-calculators/pnb-bank-sip-calculator"
              element={<PnbSipCalculator />}
            />

            <Route
              path="/financial-tools-calculators/lic-bank-sip-calculator"
              element={<LicSipCalculator />}
            />

            <Route
              path="/financial-tools-calculators/nippon-bank-sip-calculator"
              element={<NipponSipCalculator />}
            />

            <Route
              path="/financial-tools-calculators/sbi-bank-sip-calculator"
              element={<SbiSipCalculator />}
            />

            <Route
              path="/financial-tools-calculators/canara-bank-sip-calculator"
              element={<CanaraBankCalculator />}
            />

            <Route
              path="/financial-tools-calculators/axis-sip-calculator"
              element={<AxixSipCalculator />}
            />
            <Route
              path="/financial-tools-calculators/kotak-sip-calculator"
              element={<KotakSipCalculator />}
            />
            <Route
              path="/financial-tools-calculators/hdfc-sip-calculator"
              element={<HdfcSipCalculator />}
            />
            <Route
              path="/financial-tools-calculators/icici-sip-calculator"
              element={<IciciSipCalculator />}
            />
            <Route
              path="/financial-tools-calculators/health-insurance-calculator"
              element={<HealthInsuranceCalculator />}
            />

            <Route
              path="/financial-tools-calculators/bike-insurance-calculator"
              element={<BikeInsuranceCalculator />}
            />

            <Route
              path="/financial-tools-calculators/car-insurance-calculator"
              element={<CarInsuranceCalculator />}
            />

            <Route
              path="/financial-tools-calculators/travel-insurance-calculator"
              element={<TravelInsuranceCalculator />}
            />

            <Route
              path="/financial-tools-calculators/term-insurance-calculator"
              element={<TermLifeInsuranceCalculator />}
            />

            <Route
              path="/financial-tools-calculators/tds-calculator"
              element={<TDSCalculator />}
            />
            <Route
              path="/financial-tools-calculators/brokerage-calculator"
              element={<BrokerageCalculator />}
            />
            <Route
              path="/financial-tools-calculators/salary-calculator"
              element={<SalaryCalculator />}
            />
            <Route
              path="/financial-tools-calculators/inflation-calculator"
              element={<InflationCalculator />}
            />
            <Route
              path="/financial-tools-calculators/equity-margin-calculator"
              element={<EquityMarginCalculator />}
            />
            <Route
              path="/financial-tools-calculators/flat-vs-reducing-rate-calculator"
              element={<FlatReducingRateCalculator />}
            />
            <Route
              path="/financial-tools-calculators/gst-calculator"
              element={<GSTCalculator />}
            />
            <Route
              path="/financial-tools-calculators/cagr-calculator"
              element={<CAGRCalculator />}
            />
            <Route
              path="/financial-tools-calculators/apy-calculator"
              element={<APYCalculator />}
            />
            <Route
              path="/financial-tools-calculators/gratuity-calculator"
              element={<GratuityCalculator />}
            />
            <Route
              path="/financial-tools-calculators/car-loan-emi-calculator"
              element={<CarLoanEMICalculator />}
            />
            <Route
              path="/financial-tools-calculators/home-loan-emi-calculator"
              element={<HomeLoanEMICalculator />}
            />
            <Route
              path="/financial-tools-calculators/income-tax-calculator"
              element={<IncomeTaxCalculator />}
            />
            <Route
              path="/financial-tools-calculators/step-up-sip-calculator"
              element={<StepUpSIPCalculator />}
            />
            <Route
              path="/financial-tools-calculators/nsc-calculator"
              element={<NSCCalculator />}
            />
            <Route
              path="/financial-tools-calculators/compound-interest-calculator"
              element={<CompoundInterestCalculator />}
            />
            <Route
              path="/financial-tools-calculators/simple-interest-calculator"
              element={<SimpleInterestCalculator />}
            />
            <Route
              path="/financial-tools-calculators/emi-calculator"
              element={<EMICalculator />}
            />
            <Route
              path="/financial-tools-calculators/retirement-planning-calculator"
              element={<RetirementCalculator />}
            />
            <Route
              path="/financial-tools-calculators/hra-exemption-calculator"
              element={<HRACalculator />}
            />
            <Route
              path="/financial-tools-calculators/nps-calculator"
              element={<NPSCalculator />}
            />
            <Route
              path="/financial-tools-calculators/rd-calculator"
              element={<RDCalculator />}
            />
            <Route
              path="/financial-tools-calculators/fd-calculator"
              element={<FDCalculator />}
            />
            <Route
              path="/financial-tools-calculators/pf-epf-calculator"
              element={<EPFCalculator />}
            />
            <Route
              path="/financial-tools-calculators/ppf-calculator"
              element={<PPFCalculator />}
            />
            <Route
              path="/financial-tools-calculators/sukanya-samriddhi-yojana-calculator"
              element={<SSYCalculator />}
            />
            <Route
              path="/financial-tools-calculators/mutual-fund-calculator"
              element={<MutualFundCalculator />}
            />
            <Route
              path="/financial-tools-calculators/swp-calculator"
              element={<SWPCalculator />}
            />
            <Route
              path="/financial-tools-calculators"
              element={<ToolsPages />}
            />
            <Route
              path="/financial-tools-calculators/sip-calculator"
              element={<ToolOfSipLipPages />}
            />
            <Route
              path="/financial-tools-calculators/lumpsum-calculator"
              element={<ToolOfSipLipPages />}
            />

            {/* <Route path='/travel-insurance/hdfc-ergo-travel-insurance' element={<HdfcErgoTravelLearn />} />
        <Route path='/travel-insurance/care-health-travel-insurance' element={<CareHealthTravelLearn />} />
        <Route path='/travel-insurance/tata-aij-travel-insurance' element={<TataaijTravelLearn />} />
        <Route path='/travel-insurance/icici-lombard-travel-insurance' element={<IciciLombardTravelLearn />} />
        <Route path='/travel-insurance/bajaj-allianz-travel-insurance' element={<BajajTravelLearn />} /> */}
            {/* <Route path='/health-insurance/aditya-health-insurance' element={<AdityaHealthLearn />} />
        <Route path='/health-insurance/care-health-insurance' element={<CareHealthLearn />} />
        <Route path='/health-insurance/digit-health-insurance' element={<DigitHealthLearn />} />
        <Route path='/health-insurance/hdfc-ergo-health-insurance' element={<HdfcargoHealthLearn />} />
        <Route path='/health-insurance/reliance-health-insurance' element={<RelianceHealthLearn />} /> */}
            {/* <Route path='/life-insurance/adityalife-insurance' element={<AdityaLifeLearn />} />
        <Route path='/life-insurance/hdfc-life-insurance' element={<HdfcLifeLearn/>} />
        <Route path='/life-insurance/icici-life-insurance' element={<IciciLifeLearn />} />
        <Route path='/life-insurance/maxlife-insurance' element={<MaxLifeLearn />} /> */}
            {/* <Route path='/futurelife_insurance_learn_more' element={<FutureLifeLearn />} /> */}
            {/* <Route path='/bike-insurance/hdfc-bike-insurance' element={<HdfcBikeInsurance />} />
        <Route path='/bike-insurance/bajaj-bike-insurance' element={<BajajBikeInsurance />} />
        <Route path='/bike-insurance/acko-bike-insurance' element={<AckoBikeInsurance />} />
        <Route path='/bike-insurance/future-bike-insurance' element={<FutureBikeInsurance />} />
        <Route path='/bike-insurance/icici-bike-insurance' element={<IciciBikeInsurance />} />
        <Route path='/car-insurance/tata-aij-car-insurance' element={<TataAijLearnMore />} />
        <Route path='/car-insurance/hdfc-car-insurance' element={<HdfcCarLearnMore />} />
        <Route path='/car-insurance/acko-car-insurance' element={<AckoLearnMore />} />
        <Route path='/car-Insurance/icici-lombard-car-insurance' element={<IciciLombardLearn />} />
        <Route path='/car-insurance/bajaj-allianz-car-insurance' element={<BajajLearnMore />} /> */}
            <Route
              path="/learn-more-page/card"
              element={<LearnMoreAllCards />}
            />
            <Route
              path="/credit-card/aubank-credit-card"
              element={<AuBankLit />}
            />
            <Route
              path="/credit-card/eazy-diner-indusind-bank-credit-card"
              element={<EasyDinerBank />}
            />
            <Route
              path="/credit-card/hdfc-bank/millennia-credit-card"
              element={<HdfcBankMillennia />}
            />
            <Route
              path="/credit-card/sbi-simplyclick-credit-card"
              element={<SbiSimplyClick />}
            />
            <Route
              path="/credit-card/idfcfirst-classic-credit-card"
              element={<IdfcFirstClassic />}
            />
            <Route
              path="/credit-card/axis-bank-flipkart-credit-card"
              element={<FlipcartAxixBank />}
            />
            {/* <Route path='/car-loan' element={<CarLoan />} />
        <Route path='/home-loan' element={<HomeLoan />} />
        <Route path='/two-wheeler-loan' element={<TwoWheelerLoan />} />
        <Route path='/education-loan' element={<EducationLoan />} />
        <Route path='/personal-loan' element={<PersonalLoanU />} /> */}
            {/* <Route path='/learnmore_car_detail' element={<CarLoanLearnMore />} /> */}
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route
              path="/term-and-conditions"
              element={<TermsAndConditions />}
            />
            <Route
              path="/bank-of-india-bank/credit-card"
              element={<BoiBank />}
            />
            <Route path="/dbs-bank/credit-card" element={<DBS />} />
            <Route path="/indian-bank/credit-card" element={<IndianBank />} />
            <Route path="/equitas-bank/credit-card" element={<Equitas />} />
            <Route path="/ujjivan-bank/credit-card" element={<UjjivanBank />} />
            <Route path="/city-union-bank/credit-card" element={<CityBank />} />
            <Route
              path="/south-indian-bank/credit-card"
              element={<SouthIndianBank />}
            />
            <Route path="/dcb-bank/credit-card" element={<DcbBank />} />
            <Route path="/dcb-bank/credit-card" element={<DcbBank />} />
            <Route path="/jk-bank/credit-card" element={<JKBank />} />
            <Route path="/karur-vysya-bank/credit-card" element={<KvbBank />} />
            <Route path="/canara-bank/credit-card" element={<CanaraBank />} />
            <Route path="/union-bank/credit-card" element={<UnionBank />} />
            <Route
              path="/punjab-national-bank/credit-card"
              element={<PnbBank />}
            />
            <Route path="/rbl-bank/credit-card" element={<Rbl />} />
            <Route
              path="/kotak-mahindra-bank/credit-card"
              element={<KotakMahindra />}
            />
            <Route path="/amex_detail" element={<AMEX />} />
            <Route path="/au-bank/credit-card" element={<Au />} />
            <Route path="/axis-bank/credit-card" element={<AXIX />} />
            <Route path="/icici-bank/credit-card" element={<ICICI />} />
            <Route path="/idfc-bank/credit-card" element={<IDFC />} />
            <Route path="/induslnd-bank/credit-card" element={<Indulnd />} />
            <Route path="/sbi-bank/credit-card" element={<SBI />} />
            <Route path="/hdfc-bank/credit-card" element={<HDFC />} />
            <Route
              path="/bank-of-baroda/credit-card"
              element={<BankOfBaroda />}
            />
            <Route path="/citi_detail" element={<Citi />} />
            <Route path="/federal-bank/credit-card" element={<Federal />} />
            <Route path="/hsbc-bank/credit-card" element={<Hsbc />} />
            <Route path="/kotak_detail" element={<Kotak />} />
            <Route path="/american-bank/credit-card" element={<American />} />
            <Route path="/standard-bank/credit-card" element={<Standard />} />
            <Route path="/yes-bank/credit-card" element={<YesBank />} />
            <Route path="/hdfc_learn_more" element={<HdfcLearnMore />} />
            <Route
              path="/credit-card/reward-credit-card"
              element={<RewardCredit />}
            />
            <Route
              path="/credit-card/lifestyle-credit-card"
              element={<LifeStyleCreditCard />}
            />

            <Route
              path="/credit-card/business-credit-card"
              element={<BusinessCreditCard />}
            />

            <Route
              path="/credit-card/travel-credit-card"
              element={<Travel />}
            />
            <Route
              path="/credit-card/best-cashback-credit-card"
              element={<CashBack />}
            />
            <Route
              path="/credit-card/best-premium-credit-card"
              element={<Premium />}
            />
            <Route
              path="/credit-card/best-lifetime-free-credit-cards"
              element={<LifeTimeFee />}
            />
            <Route path="/credit-card/fuel-credit-card" element={<Fuel />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact-us" element={<ContactPage />} />
            <Route path="/credit-card" element={<CreditCardPage />} />
            {/* <Route path='/demat_learn_more' element={<DematLearnMore />} /> */}
            {/* <Route path='/detailofbank' element={<BankDetail />} /> */}
            {/* <Route path='/personal_loan' element={<PersonalLoan />} /> */}
        
            {/* <Route path='/demat' element={<Demat />} /> */}
            {/* <Route path='/research' element={<ResearchPage />} /> */}
         
            {/* <Route path='/insurance' element={<InsurancePage />} /> */}
            {/* <Route path='/life-Insurance' element={<LifeInsurance />} />
        <Route path='/health-insurance' element={<HealthInsurance />} />
        <Route path='/car-insurance' element={<CarInsurance />} />
        <Route path='/bike-insurance' element={<BikeInsurance />} /> */}
            {/* <Route path='/term_insurance' element={<TermInsurance />} /> */}
            {/* <Route path='/travel-insurance' element={<TravelInsurance />} /> */}
            {/* <Route path='/blog' element={<BlogPage />} /> */}
            {/* <Route path='/blog_page/:id' element={<BlogPost />} /> */}
            {/* <Route path='/video/:id' element={<VideoDetail />} />
          <Route path='/channel/:id' element={<ChannelDetail />} />
          <Route path='/search/:searchTerm' element={<SearchFeed />} /> */}
          </Routes>
          <LayoutGTM>
            <FooterComponent />
          </LayoutGTM>
        </LayoutScroll>
      </Layout>

      {/* </Box> */}
    </>
  );
}

export default App;
